@if (isLoading) {
<div class="panel-title-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
}
@else {
<h2 class="panel-title">{{('Modules.Licenses.List.OrderHistory.Orders' | translate)}}</h2>

<div *ngIf="orderedLicenses.length">
  <div class="padding-list">
    <ng-container *ngFor="let order of orderedLicenses">
      <app-list-item title="{{ order.id }}" [info]="getInfoString(order)" showActionIcon="true"
        (click)="onOrderClick(order)" [showItemStatus]="false" [disabled]="isLoadingOrderDetails">
      </app-list-item>
    </ng-container>

    <div class="action-buttons" *ngIf="hasMore">
      <ng-container *ngIf="isLoadingMore; then loading else loadAction"></ng-container>

      <ng-template #loadAction>
        <button mat-flat-button class="button small-button" (click)="loadMore()">
          <mat-icon>update</mat-icon>
          <p>{{ 'General.LoadMore' | translate }}</p>
        </button>
      </ng-template>

      <ng-template #loading>
        <mat-spinner class="spinner" diameter="28"></mat-spinner>
      </ng-template>
    </div>
  </div>
</div>
<div *ngIf="orderedLicenses?.length === 0" class="panel-no-data">
  {{ 'Modules.Licenses.List.OrderHistory.NoData' | translate }}
</div>
}